import '../Header/Header.js';
import '../Visa-check/Visa-check.js';
import '../Visa-choice/Visa-choice.js';
import '../Visa-order/Visa-order-applications.js';
import '../Visa-order/Visa-order-check.js';
import '../Orders/Orders.js';
import './form-date.js';
import './form-validate.js';
import { Popup } from '../Popup/Popup.js';
import { initAuthPopup } from '../Popup/Popup-auth.js';
import { initOrderPaidPopup } from '../Popup/Popup-order-paid.js';
import { initHeaderAuth } from '../Header/Header-auth.js';
import { initCookieNotice } from '../Cookie-notice/Cookie-notice.js';

window.popup = new Popup();
window.popup.applyEvents();
initAuthPopup();
initOrderPaidPopup();
initHeaderAuth();
initCookieNotice();

const doc = document.documentElement;

function updateCssVars() {
	doc.style.setProperty('--app-height', window.innerHeight + 'px');

	const header = document.querySelector('.header');
	if (header) doc.style.setProperty('--header-height', header.offsetHeight + 'px');
}

updateCssVars();
window.addEventListener('load', updateCssVars);
window.addEventListener('resize', updateCssVars);


// Плавный (инерционный) скролл на одном rAF-цикле — без лагов.
// Уважаем системную настройку "уменьшить движение".
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// ВРЕМЕННО ОТКЛЮЧЕНО: плавный (Lenis) скролл на всём сайте. Чтобы вернуть — true.
// Без него всё работает на нативном скролле (у якорей и переключения анкет есть
// нативные фолбэки, бургер-меню держит блокировку через body.no-scroll).
const SMOOTH_SCROLL_ENABLED = false;

if (SMOOTH_SCROLL_ENABLED && window.Lenis && !prefersReducedMotion) {
	const lenis = new Lenis({
		duration: 1.2,          // выше значение — медленнее/плавнее скролл
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		smoothWheel: true,      // плавно для мыши/тачпада
		syncTouch: true,        // инерция и на тач-устройствах
	});
	window.lenis = lenis;

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}
	requestAnimationFrame(raf);
}


// Якоря в пределах текущей страницы (напр. меню «Проверка нужна ли виза» → /#visa-check):
// если цель есть на этой же странице — плавно прокручиваем (Lenis или нативно), с учётом
// высоты шапки. На другой странице ссылку не трогаем — браузер перейдёт и прыгнет к якорю.
document.addEventListener("click", (e) => {
	const link = e.target.closest('a[href*="#"]');
	if (!link) return;

	const url = new URL(link.href, location.href);
	if (url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;

	let target;
	try { target = document.querySelector(url.hash); } catch (_) { return; }
	if (!target) return;

	e.preventDefault();
	const header = document.querySelector(".header");
	const offset = header ? -header.offsetHeight : 0;

	if (window.lenis) {
		window.lenis.scrollTo(target, { offset });
	} else {
		const top = target.getBoundingClientRect().top + window.pageYOffset + offset;
		window.scrollTo({ top, behavior: "smooth" });
	}
	history.replaceState(null, "", url.hash);
});


document.querySelectorAll(".form-custom-select").forEach(initCustomSelect);

function initCustomSelect(root) {
	const input = root.querySelector(".form-custom-select__field-input");
	const choiceInputs = root.querySelectorAll(".form-custom-select__choice-input");
	const selected = root.querySelector(".form-custom-select__selected");
	if (!input || !choiceInputs.length) return;

	const isMulti = choiceInputs[0].type === "checkbox";
	const isReadonly = input.hasAttribute("readonly");

	const open = () => root.classList.add("active");
	const close = () => root.classList.remove("active");

	input.addEventListener("focus", open);
	input.addEventListener("click", open);

	if (!isReadonly) {
		input.addEventListener("input", () => {
			const q = input.value.trim().toLowerCase();
			root.querySelectorAll(".form-custom-select__choice-item").forEach((item) => {
				const text = item.textContent.trim().toLowerCase();
				item.hidden = q && !text.includes(q);
			});
		});
	}

	choiceInputs.forEach((opt) => {
		opt.addEventListener("change", () => {
			const label = root.querySelector(`label[for="${opt.id}"] .form-custom-select__choice-caption`);
			const text = label ? label.textContent.trim() : "";

			if (isMulti) {
				if (opt.checked) addChip(selected, opt.id, text);
				else removeChip(selected, opt.id);
			} else {
				input.value = text;
				// программная установка value не шлёт событие — диспатчим change сами,
				// чтобы зависимая логика (валидация подсветки) сработала сразу (не со 2-го раза)
				input.dispatchEvent(new Event("change", { bubbles: true }));
				close();
				input.blur();
			}
		});
	});

	if (selected) {
		selected.addEventListener("click", (e) => {
			const btn = e.target.closest(".form-custom-select__selected-remove");
			if (!btn) return;
			const optId = btn.dataset.id;
			const opt = document.getElementById(optId);
			if (opt) opt.checked = false;
			btn.closest(".form-custom-select__selected-item").remove();
		});
	}

	document.addEventListener("click", (e) => {
		if (!root.contains(e.target)) close();
	});
}

function addChip(container, optId, text) {
	if (!container) return;
	const list = container.querySelector(".form-custom-select__selected-list");
	if (!list || list.querySelector(`[data-id="${optId}"]`)) return;

	const li = document.createElement("li");
	li.className = "form-custom-select__selected-item";
	li.innerHTML = `
		<span class="form-custom-select__selected-caption"></span>
		<button class="form-custom-select__selected-remove" type="button" data-id="${optId}" aria-label="Удалить">
			<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
				<path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
			</svg>
		</button>
	`;
	li.querySelector(".form-custom-select__selected-caption").textContent = text;
	list.appendChild(li);
}

function removeChip(container, optId) {
	if (!container) return;
	const btn = container.querySelector(`.form-custom-select__selected-remove[data-id="${optId}"]`);
	if (btn) btn.closest(".form-custom-select__selected-item").remove();
}
